module.exports = __webpack_public_path__ + "static/media/phone-grey-ico.11278e61.svg";